function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.32 20.18L21 13.5l-1.18-1.18-5.5 5.48-2.14-2.16L11 16.82l3.32 3.36zM16 8.5a.79.79 0 00-.58.24.79.79 0 00-.24.58c0 .227.08.427.24.6a.76.76 0 00.58.26.76.76 0 00.58-.26.858.858 0 00.24-.6.79.79 0 00-.24-.58.79.79 0 00-.58-.24zm5.82 0c.453 0 .847.167 1.18.5.333.333.5.727.5 1.18v11.64c0 .453-.167.847-.5 1.18-.333.333-.727.5-1.18.5H10.18c-.453 0-.847-.167-1.18-.5a1.614 1.614 0 01-.5-1.18V10.18c0-.453.167-.847.5-1.18.333-.333.727-.5 1.18-.5h3.48a2.52 2.52 0 01.89-1.21A2.36 2.36 0 0116 6.82c.547 0 1.03.157 1.45.47.42.313.717.717.89 1.21h3.48z",
  fill: "#4A4A4A",
  fillRule: "evenodd"
})));